// List of types: https://www.iana.org/assignments/dns-parameters/dns-parameters.xhtml#dns-parameters-4
export var DNSRecordType;
(function (DNSRecordType) {
    DNSRecordType[DNSRecordType["NS"] = 2] = "NS";
    DNSRecordType[DNSRecordType["CNAME"] = 5] = "CNAME";
    DNSRecordType[DNSRecordType["TXT"] = 16] = "TXT";
})(DNSRecordType || (DNSRecordType = {}));
/**
 * Logger Interface
 */
export const LOG_LEVELS = ['trace', 'info', 'warn', 'error', 'silent'];
//# sourceMappingURL=types.js.map